import { render } from "./GalleryDetail.vue?vue&type=template&id=a31cd18a&scoped=true"
import script from "./GalleryDetail.vue?vue&type=script&lang=js"
export * from "./GalleryDetail.vue?vue&type=script&lang=js"

import "./GalleryDetail.vue?vue&type=style&index=0&id=a31cd18a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a31cd18a"]])

export default __exports__